import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import './UserAccessHistoryCtrl.css';

export function UserAccessHistoryRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserAccessHistory', {
		url: '/admin/users/:id/access/history',
		controllerAs: 'vm',
		controller: UserAccessHistoryCtrl,
		templateUrl: '/ng/hub/User/Access/History/UserAccessHistoryCtrl.html?' + window.BUILD,
		resolve: {
			$title: () => 'Users Access History',
			user: ApiResourcify.endpoint('/users/:id'),
			editorAccess: ApiResourcify.endpoint('/users/me/access'),
			history: ApiResourcify.endpoint('/users/:id/access/history?order_by=-updated_at'),
			roles: ApiResourcify.endpoint('/users/roles', { cacheFor: 30 * 60 * 1000 }),
		},
	});
}

export class UserAccessHistoryCtrl {
	constructor(Api, Cfg, modal, user, editorAccess, history, roles) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.modal = modal;
		this.user = user;
		this.history = history;
		// setup values we need
		this.sort = '-updated_at';
		this.roleLabels = {};
		roles.forEach(role => {
			this.roleLabels[role.role] = role.label;
		});
		this.isPostApprovalEnabled = Cfg.read('Features.post_approval') === '1';
		this.editorIsAccountManager = editorAccess.accounts.some(a => a.is_admin);
	}

	rollbackAccess(hist) {
		const msg = 'Are you sure you want to rollback to this point? This cannot be undone.';
		this.modal.confirm({ text: msg }).then(() => {
			this.enlarged = false;
			this.isRollingBack = true;
			this.history = [];
			this.Api.post(`/users/${this.user.id}/access/rollback`, { history_id: hist.id }).then(() => {
				window.location.reload();
			});
		});
	}
}
